// Timed auto-resume durations for the production hold (ADR 0055). The operator
// picks how long a pause/hold lasts before it auto-resumes; "Until I resume" (0)
// is the manual, open-ended hold. Shared by the Director console + Go-Live panel.
export interface HoldDuration {
  value: string; // seconds as a string (Select option value); "0" = manual
  label: string;
}

export const HOLD_DURATIONS: HoldDuration[] = [
  { value: "0", label: "Until I resume" },
  { value: "30", label: "30s" },
  { value: "60", label: "1m" },
  { value: "300", label: "5m" },
];
